import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import CommonModal from '../../../Common/Modal/Modal';
import SiteImage from '../SiteImage';
import Button from '../../../Button/Button';

const SitePhotoPreviewModal = ({
  currentSiteImages,
  siteId,
  organizationId,
  isShow = false,
  onClose = () => {},
  isModal,
  initialImageId = null,
}) => {
  const [modalImageId, setModalImageId] = useState(null);

  useEffect(() => {
    if (isShow) {
      setModalImageId(initialImageId);
    }
  }, [initialImageId, isShow]);

  const onEditClicked = (e) => {
    e.preventDefault();
    onClose({ shouldOpenEditModal: true });
  };

  if (!isShow || !currentSiteImages.length) return null;

  return (
    <CommonModal title="Images" titlePosition="left" titleStyle="text-2xl font-bold" handleClose={() => onClose({ shouldOpenEditModal: false })} headerClassName="p-6" className="w-249">
      <div>
        <div className="flex justify-end pr-14 py-8">
          <Button onClick={onEditClicked} size="md" label="Edit" />
        </div>
        <div className="px-13">
          <SiteImage images={currentSiteImages} siteId={siteId} organizationId={organizationId} heightStyle="h-[400px]" isModal={isModal} modalImageId={modalImageId} setModalImageId={setModalImageId} />
        </div>
        <div className="pb-15">
          {currentSiteImages.length > 1 && (
            <div className="pt-6 px-13">
              <div className="grid grid-cols-4 gap-8">
                {currentSiteImages.slice(0, 4).map((siteImage, index) => (
                  <button
                    type="button"
                    onClick={() => setModalImageId(siteImage.id)}
                    key={siteImage?.id || index}
                  >
                    <img
                      src={siteImage?.image?.url || ''}
                      alt={`Preview ${index + 1}`}
                      className="w-full h-32 object-cover rounded-lg"
                    />
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>
      </div>
    </CommonModal>
  );
};

SitePhotoPreviewModal.propTypes = {
  siteId: PropTypes.number.isRequired,
  organizationId: PropTypes.number.isRequired,
  currentSiteImages: PropTypes.arrayOf(PropTypes.object).isRequired,
  isShow: PropTypes.bool,
  onClose: PropTypes.func,
  isModal: PropTypes.bool.isRequired,
  initialImageId: PropTypes.number,
};

export default SitePhotoPreviewModal;
